export class BuildingLevelFull {
  /**
   *
   */
  public id: number | null = null;

  /**
   *
   */
  public niveau = '';

  /**
   *
   */
  public batiment = '';

  /**
   *
   */
  public oldNameNiveau = '';

  /**
   *
   */
  public oldNameBat = '';

  /**
   *
   */
  public time: Date = new Date();

  /**
   *
   */
  public fichier = '';

  /**
   *
   */
  public zoom: number | null = null;

  /**
   *
   */
  public fichierpdf = '';

  /**
   *
   */
  public zoompdf = '';

  /**
   *
   */
  public group1 = '';

  /**
   *
   */
  public info = '';

  /**
   *
   */
  public unitscaling = 0;

  /**
   *
   */
  public group2 = '';

  /**
   *
   */
  public additionalInfos = '';

  /**
   *
   */
  public levelv = 0;

  /**
   *
   */
  public levelx = 0;

  /**
   *
   */
  public right_level = 0;

  /**
   *
   */
  public oldfichierpdf = '';

  /**
   *
   */
  public minimumUserPermission = 0;

  /**
   *
   */
  public flag = 0;

  /**
   *
   */
  public guid: string | null = null;

  /**
   *
   */
  public lock_date = 0;

  /**
   *
   */
  public start_date = 0;

  /**
   *
   */
  public allowed_camp: string | null = null;
}
